<template>
  <el-row class="container">

    <el-col :span="24" class="header">
      <el-col :span="1">
        <div class="tools" @click.prevent="collapse">
          <i class="el-icon-menu" style="font-size: 30px;line-height: 45px;margin-left: 15px;color: white;"></i>
        </div>
      </el-col>
      <el-col :span="6" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'" >
        <img  v-if="$store.getters.systemCpy==1" @click="logClick" style="cursor: pointer;" src="../assets/home2.png"/>
        <img  v-if="$store.getters.systemCpy==2" @click="logClick" src="../assets/blueoak/logo3.png"  style="width: 43px !important;cursor: pointer;"/>
      </el-col>

      <div style="float: left;"><i class="fa fa-user-circle-o fa-2x" style="height: 45px;line-height: 45px;font-size: 20px"></i>
          <span style="    font-size: 14px;">&nbsp&nbsp歡迎 : {{staff.name}}</span></div>

      <el-drawer
              title="備忘錄" size="50%"
              :visible.sync="drawer"
              :direction="drawerDirection"
              >
        <el-collapse v-model="activeNames" @change="handleDrawerChange">
          <el-collapse-item title="當天已認證預約資料" name="1" style="margin-left: 15px;">
            <el-table
                    :data="overseaList[0]"
                    stripe
                    border show-summary :summary-method="getSummaries"
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
                <el-table-column
                        prop="insurance"
                        align="left" :show-overflow-tooltip="true"
                        label="保險公司">
                </el-table-column>
                <el-table-column
                        prop="totalCases" width="80px"
                        align="right" :show-overflow-tooltip="true"
                        label="單量">
                </el-table-column>
                <el-table-column
                        prop="totalAmt"
                        align="right" :show-overflow-tooltip="true"
                        label="金額 (HKD)">
                  <template slot-scope="scope">
                    {{scope.row.totalAmt | currency('')}}
                  </template>
                </el-table-column>
            </el-table>
          </el-collapse-item>
          <!--<el-collapse-item title="明天預約申請資料" name="2" style="margin-left: 15px;">
            <el-table
                    :data="overseaList[1]"
                    stripe :summary-method="getSummaries"
                    border show-summary
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
              <el-table-column
                      prop="insurance"
                      align="left" :show-overflow-tooltip="true"
                      label="保險公司">
              </el-table-column>
              <el-table-column
                      prop="totalCases" width="80px"
                      align="right" :show-overflow-tooltip="true"
                      label="單量">
              </el-table-column>
              <el-table-column
                      prop="totalAmt"
                      align="right" :show-overflow-tooltip="true"
                      label="金額">
                <template slot-scope="scope">
                  {{scope.row.totalAmt | currency('')}}
                </template>
              </el-table-column>


            </el-table>
          </el-collapse-item>
          <el-collapse-item title="7天內尚未認證資料" name="3" style="margin-left: 15px;">
            <el-table
                    :data="overseaList[2]"
                    stripe :summary-method="getSummaries"
                    border show-summary
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
              <el-table-column
                      prop="insurance"
                      align="left" :show-overflow-tooltip="true"
                      label="保險公司">
              </el-table-column>
              <el-table-column
                      prop="totalCases" width="80px"
                      align="right" :show-overflow-tooltip="true"
                      label="單量">
              </el-table-column>
              <el-table-column
                      prop="totalAmt"
                      align="right" :show-overflow-tooltip="true"
                      label="金額">
                <template slot-scope="scope">
                  {{scope.row.totalAmt | currency('')}}
                </template>
              </el-table-column>


            </el-table>
          </el-collapse-item>
          <el-collapse-item title="14天內尚未認證資料" name="4" style="margin-left: 15px;">
            <el-table
                    :data="overseaList[3]"
                    stripe :summary-method="getSummaries"
                    border show-summary
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
              <el-table-column
                      prop="insurance"
                      align="left" :show-overflow-tooltip="true"
                      label="保險公司">
              </el-table-column>
              <el-table-column
                      prop="totalCases" width="80px"
                      align="right" :show-overflow-tooltip="true"
                      label="單量">
              </el-table-column>
              <el-table-column
                      prop="totalAmt"
                      align="right" :show-overflow-tooltip="true"
                      label="金額">
                <template slot-scope="scope">
                  {{scope.row.totalAmt | currency('')}}
                </template>
              </el-table-column>


            </el-table>
          </el-collapse-item>
          <el-collapse-item title="當月尚未認證資料" name="5" style="margin-left: 15px;">
            <el-table
                    :data="overseaList[4]"
                    stripe :summary-method="getSummaries"
                    border show-summary
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
              <el-table-column
                      prop="insurance"
                      align="left" :show-overflow-tooltip="true"
                      label="保險公司">
              </el-table-column>
              <el-table-column
                      prop="totalCases" width="80px"
                      align="right" :show-overflow-tooltip="true"
                      label="單量">
              </el-table-column>
              <el-table-column
                      prop="totalAmt"
                      align="right" :show-overflow-tooltip="true"
                      label="金額">
                <template slot-scope="scope">
                  {{scope.row.totalAmt | currency('')}}
                </template>
              </el-table-column>


            </el-table>
          </el-collapse-item>-->
          <el-collapse-item title="自訂時間段未認證資料" name="6" style="margin-left: 15px;">
            <el-form>
              <el-date-picker size="small"
                      v-model="overseaDatePeriod"
                      type="daterange"
                      align="right"
                      unlink-panels format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="開始日期"
                      end-placeholder="結束日期" value-format="timestamp"
                      :picker-options="pickerOptions1" style="width:380px;margin-left: 10px;margin-bottom: 15px;">
              </el-date-picker>
              <el-button type="primary" @click="queryHomeMemoByDate" size="small">GO</el-button>
            </el-form>
            <el-table
                    v-loading="overseaListLoading"
                    :data="overseaList[5]"
                    stripe :summary-method="getSummaries"
                    border show-summary
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
              <el-table-column
                      prop="insurance"
                      align="left" :show-overflow-tooltip="true"
                      label="保險公司">
              </el-table-column>
              <el-table-column
                      prop="totalCases" width="80px"
                      align="right" :show-overflow-tooltip="true"
                      label="單量">
              </el-table-column>
              <el-table-column
                      prop="totalAmt"
                      align="right" :show-overflow-tooltip="true"
                      label="金額 (HKD)">
                <template slot-scope="scope">
                  {{scope.row.totalAmt | currency('')}}
                </template>
              </el-table-column>


            </el-table>
          </el-collapse-item>
          <el-collapse-item title="自訂時間段已認證資料" name="7" style="margin-left: 15px;">
            <el-form>
              <el-date-picker size="small"
                              v-model="overseaDatePeriod2"
                              type="daterange"
                              align="right"
                              unlink-panels format="yyyy-MM-dd"
                              range-separator="至"
                              start-placeholder="開始日期"
                              end-placeholder="結束日期" value-format="timestamp"
                              :picker-options="pickerOptions1" style="width:380px;margin-left: 10px;margin-bottom: 15px;">
              </el-date-picker>
              <el-button type="primary" @click="queryHomeMemoByDateCerted" size="small">GO</el-button>
            </el-form>
            <el-table
                    v-loading="overseaListLoading2"
                    :data="overseaList[6]"
                    stripe :summary-method="getSummaries"
                    border show-summary
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
              <el-table-column
                      prop="insurance"
                      align="left" :show-overflow-tooltip="true"
                      label="保險公司">
              </el-table-column>
              <el-table-column
                      prop="totalCases" width="80px"
                      align="right" :show-overflow-tooltip="true"
                      label="單量">
              </el-table-column>
              <el-table-column
                      prop="totalAmt"
                      align="right" :show-overflow-tooltip="true"
                      label="金額 (HKD)">
                <template slot-scope="scope">
                  {{scope.row.totalAmt | currency('')}}
                </template>
              </el-table-column>


            </el-table>
          </el-collapse-item>
          <el-collapse-item title="自訂時間段已取消資料" name="8" style="margin-left: 15px;">
            <el-form>
              <el-date-picker size="small"
                              v-model="overseaDatePeriod3"
                              type="daterange"
                              align="right"
                              unlink-panels format="yyyy-MM-dd"
                              range-separator="至"
                              start-placeholder="開始日期"
                              end-placeholder="結束日期" value-format="timestamp"
                              :picker-options="pickerOptions1" style="width:380px;margin-left: 10px;margin-bottom: 15px;">
              </el-date-picker>
              <el-button type="primary" @click="queryHomeMemoByDateCancel" size="small">GO</el-button>
            </el-form>
            <el-table
                    v-loading="overseaListLoading3"
                    :data="overseaList[7]"
                    stripe :summary-method="getSummaries"
                    border show-summary
                    style="width: 90%;margin-left: 10px;margin-bottom: 20px;">
              <el-table-column
                      prop="nameChi"
                      align="left" :show-overflow-tooltip="true"
                      label="合作夥伴">
              </el-table-column>
              <el-table-column
                      prop="insurance"
                      align="left" :show-overflow-tooltip="true"
                      label="保險公司">
              </el-table-column>
              <el-table-column
                      prop="totalCases" width="80px"
                      align="right" :show-overflow-tooltip="true"
                      label="單量">
              </el-table-column>
              <el-table-column
                      prop="totalAmt"
                      align="right" :show-overflow-tooltip="true"
                      label="金額 (HKD)">
                <template slot-scope="scope">
                  {{scope.row.totalAmt | currency('')}}
                </template>
              </el-table-column>


            </el-table>
          </el-collapse-item>
        </el-collapse>






      </el-drawer>

      <el-col :span="4" class="topmenu">
        <div id="admin_font">

          <div @click="openDrawer" class="home_top_function" v-if="overseaMemo" >
            <el-tooltip effect="dark" content="備忘錄" placement="bottom" >
              <i class="fa fa-paperclip fa-2x"  style="line-height: 45px;font-size: 20px;"></i>
            </el-tooltip>
          </div>

          <div class="home_top_function" >
            <el-popover
                    placement="bottom"
                    title="表格文字大小"
                    width="200"
                    trigger="hover"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
              <div class="block">
                <el-slider v-model="fontSize" :max="30" :min="6" @change="changeFontSize"></el-slider>
                <el-button size="small" type="primary" @click="saveFontSize" style="margin-bottom: 10px;">保存</el-button>
              </div>
              <el-button slot="reference" style="background-color: #403838;border: 0px;color: white;    width: 0px;">
                <i class="fa fa-font fa-2x"  style="font-size: 20px;"></i>
              </el-button>
            </el-popover>
          </div>



          <div @click="handleFullScreen" class="home_top_function" >
            <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom" >
              <i class="fa fa-arrows-alt fa-2x"  style="line-height: 45px;font-size: 20px;"></i>
            </el-tooltip>
          </div>

          <div @click="logout" class="home_top_function">
            <el-tooltip effect="dark" content="登出" placement="bottom" >
              <i class="fa fa-power-off fa-2x"  style="line-height: 45px;font-size: 20px;"></i>
            </el-tooltip>
          </div>

          <!--<el-dropdown trigger="click">
              &lt;!&ndash;<span class="el-dropdown-link userinfo-inner"><i class="fa fa-user-o none"/>{{staff.name}} </span>&ndash;&gt;
              &lt;!&ndash;<span class="el-dropdown-link userinfo-inner"><i class="fa fa-list-ul"/>{{staff.name}}</span>&ndash;&gt;
              <el-dropdown-menu slot="dropdown" style="margin-top: -1.5%;" >
              &lt;!&ndash;<el-dropdown-item divided @click.native="updpwd">修改密碼</el-dropdown-item>&ndash;&gt;
              <el-dropdown-item  @click.native="logout">退出登錄</el-dropdown-item>
              <el-dropdown-item  @click.native="goTest">Test</el-dropdown-item>
              <el-dropdown-item  @click.native="pdfDl">PDF</el-dropdown-item>
              <el-dropdown-item  @click.native="handleFullScreen"><span v-if="!fullscreen">全屏</span><span v-else>取消全屏</span></el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>-->
        </div>
      </el-col>
    </el-col>
    <!-- 修改密碼彈出框-->
    <el-dialog title="修改密碼"  :visible.sync="dialogFormVisible" width="400px">
      <el-form :model="homeForm"  size="small"  ref="homeForm" label-width="120px">
        <el-form-item label="輸入新密碼" prop="password">
          <el-input type="password"  v-model="homeForm.password"  auto-complete="off" :placeholder="placeholder" widht="160px" placeholder="請輸入新密碼"></el-input>
        </el-form-item>
        <el-form-item label="確認新密碼" label-width="120px" prop="confirmPassword">
          <el-input type="password" v-model="homeForm.confirmPassword"  auto-complete="off" :placeholder="conFirmPlaceholder" widht="160px" placeholder="请確認新密碼"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"  icon="el-icon-check" @click="modifyStaffPassword(homeForm)" plain>確 定</el-button>
          <el-button @click="dialogFormVisible = false" icon="el-icon-delete" plain>取 消</el-button>
        </el-form-item>


      </el-form>

      <!--<div slot="footer" class="dialog-footer" label-width="120px">-->
        <!--<el-button @click="dialogFormVisible = false">取消</el-button>-->
        <!--<el-button type="primary" @click="modifyStaffPassword(homeForm)">確認</el-button>-->
      <!--</div>-->
    </el-dialog>

    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--導航菜單-->
        <el-menu active-text-color="#2979ff"
                 :default-active="onRoutes" @open="handleopen" @close="handleclose" @select="handleselect" unique-opened router :collapse="collapsed">
          <menu-tree :nodes="$router.options.routes" ></menu-tree>
        </el-menu>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">

          <!--<el-col :span="24">-->
          <!--<div  class="breadcrumb-container">-->
          <!--<el-breadcrumb separator="/">-->
          <!--<el-breadcrumb-item :to="{ path: '/homepage' }"><i class="fa fa-home fa-lg"></i></el-breadcrumb-item>-->
          <!--<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">-->
          <!--{{ item.name }}-->
          <!--</el-breadcrumb-item>-->
          <!--</el-breadcrumb>-->

          <!--</div>-->
          <!--</el-col>-->

          <div class="tab_list" id="faart">
          <template v-for="tab in tabs">
          <span style="margin-right: 15px;margin-bottom: 6px;display: inline-block;position: relative;padding: 5px 0 0 5px;">
          <el-button  @click="toTab(tab)"  size="medium" :type="$route.name==tab.name?'primary':'info'" circle  >
            {{tab.name}}
                                    <i class="el-icon-error" @click.stop ="closeTab(tab.name)" v-if="$route.name!=tab.name"></i>
          </el-button>
            <!--<i class="el-icon-error" @click="colseTab(tab.name)" v-if="$route.name!=tab.name" style="position: absolute;right: -8px;top: -4px;"></i>-->
          </span>
          </template>
          </div>



          <el-col :span="24" class="content-wrapper">
            <transition name="fade-transform" mode="out-in" >
              <keep-alive exclude="Test">
                <router-view></router-view>
              </keep-alive>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
    import router from '@/router/router'
    import parseMenu from '@/utils/MenuUtil'
    import MenuTree from '@/components/MenuTree'
    import {getLogout ,updateFontSize,queryHomeMemo,queryHomeMemoByDate,queryHomeMemoByDateCerted,queryByDateWithCancel} from '../api/api'
    import axios from 'axios';
    export const formatMoney = (number, decimals, decPoint = '.', thousandsSep = ',') => {
      number = (number + '').replace(/[^0-9+-Ee.]/g, '')
      let n = !isFinite(+number) ? 0 : +number
      let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
      let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
      let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
      let s = ''
      let toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec)
        return '' + Math.ceil(n * k) / k
      }
      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
      let re = /(-?\d+)(\d{3})/
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, '$1' + sep + '$2')
      }
      if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
      }
      return s.join(dec)
    }
    export default {

        data() {

            var checkPwd2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("新密碼不能為空"));
                }else if (value.length<6||value.length>20){
                    callback(new Error("新密碼長度在6至20位之間"));
                } else if (value !== this.homeForm.password) {
                    callback(new Error("兩次輸入密碼不一致"));
                } else {
                    callback();
                }
            };
            return {
                windowWidth: 0,
                logBg:true,
                dialogTableVisible: false,
                dialogFormVisible: false,
                conFirmPlaceholder:"",
                searchs:null,
                placeholder: "",
                homeForm: {
                    region: '',
                    delivery: false,
                    resource: '',
                    desc: '',
                    password: '',
                    confirmPassword:''
                },
              collapsed:false,
              content: "<h1>Some initial content</h1>",
              fullscreen:false,
              open:true,
              fontSizeAdjustView:false,
              fontSize:this.$store.getters.staff.fontSize,
              systemCpy:"",
              drawer:false,
              drawerDirection:'rtl',
              overseaList:[],
              activeNames:[],
              overseaDatePeriod:[],
              overseaDatePeriod2:[],
              overseaDatePeriod3:[],
              pickerOptions1:{
                shortcuts: [{
                  text: '最近一周',
                  onClick(picker) {
                    const a = new Date();
                    const end = new Date(a.getFullYear()+"-"+(a.getMonth()+1)+"-"+a.getDate());
                    const start = new Date(a.getFullYear()+"-"+(a.getMonth()+1)+"-"+a.getDate());
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                    picker.$emit('pick', [start, end]);
                  }
                }, {
                  text: '最近30天',
                  onClick(picker) {
                    const a = new Date();
                    const end = new Date(a.getFullYear()+"-"+(a.getMonth()+1)+"-"+a.getDate());
                    const start = new Date(a.getFullYear()+"-"+(a.getMonth()+1)+"-"+a.getDate());
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                  }
                }, {
                  text: '最近90天',
                  onClick(picker) {
                    const a = new Date();
                    const end = new Date(a.getFullYear()+"-"+(a.getMonth()+1)+"-"+a.getDate());
                    const start = new Date(a.getFullYear()+"-"+(a.getMonth()+1)+"-"+a.getDate());
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                  }
                }]
              },
              overseaListLoading:false,
              overseaListLoading2:false,
              overseaListLoading3:false,

            }
        },
        components:{
            MenuTree
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
        },
        methods: {
          getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = 'Total';
                return;
              }
              if(index===1){
                sums[index] = ' ';
                return ;
              }
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(value => isNaN(value))) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index] += '';
              } else {
                sums[index] = 'N/A';
              }
            });
            sums.forEach((v,i)=>{
              if(i>1){
                sums[i] = formatMoney(v,2);
              }
            });
            return sums;
          },
          queryHomeMemoByDateCancel(){
            this.overseaListLoading3=true;
            let params = {startDate:this.overseaDatePeriod3[0]/1000,endDate:this.overseaDatePeriod3[1]/1000};
            return queryByDateWithCancel(params).then(res=>{
              if(res.errcode==200){
                this.overseaList[7]=res.data;
                this.overseaListLoading3=false;
              }else{
                this.$message.error(res.errmsg);
              }
            }).catch((error)=>{
              console.log("queryHomeMemo Error");
            })
          },
          queryHomeMemoByDateCerted(){
            this.overseaListLoading2=true;
            let params = {startDate:this.overseaDatePeriod2[0]/1000,endDate:this.overseaDatePeriod2[1]/1000};
            return queryHomeMemoByDateCerted(params).then(res=>{
              if(res.errcode==200){
                this.overseaList[6]=res.data;
                this.overseaListLoading2=false;
              }else{
                this.$message.error(res.errmsg);
              }
            }).catch((error)=>{
              console.log("queryHomeMemo Error");
            })
          },
          queryHomeMemoByDate(){
            this.overseaListLoading=true;
            let params = {startDate:this.overseaDatePeriod[0]/1000,endDate:this.overseaDatePeriod[1]/1000};
            return queryHomeMemoByDate(params).then(res=>{
              if(res.errcode==200){
                this.overseaList[5]=res.data;
                this.overseaListLoading=false;
              }else{
                this.$message.error(res.errmsg);
              }
            }).catch((error)=>{
              console.log("queryHomeMemo Error");
            })
          },
          handleDrawerChange(){

          },
          openDrawer(){
            this.drawer=true;
            this.queryHomeMemo();
            let a="";
            for(var i =0;i<document.styleSheets.length;i++){
              var rules;
              if(document.styleSheets[i].cssRules){
                rules = document.styleSheets[i].cssRules;
              }else{
                rules = document.styleSheets[i].rules;
              }
              for(var j=0;j<rules.length;j++){
                if(rules[j].selectorText == '.el-drawer'){
                  a= rules[j].style;
                  break;
                }
              }
            }
            a.overflow="auto";
          },
          queryHomeMemo(){
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            return queryHomeMemo().then(res=>{
              if(res.errcode==200){
                this.overseaList=res.data;
                loading.close();
              }else{
                this.$message.error(res.errmsg);
              }
            }).catch((error)=>{
              console.log("queryHomeMemo Error");
            })
          },
          handleClose(done) {
            this.$confirm('確認關閉？')
                    .then(_ => {
                      done();
                    })
                    .catch(_ => {});
          },
          saveFontSize(){
            let params ={fontSize:this.fontSize,
              staffId:this.$store.getters.staff.id};
            return updateFontSize(params).then(res=>{
              if(res.errcode==200){
                this.$message.success("保存成功");
              }else{
                this.$message.error(res.errmsg);
              }
            }).catch((error)=>{
              console.log("saveFontSize Error");
            });
          },
          changeFontSize(val){
            let a = '';
            for(var i =0;i<document.styleSheets.length;i++){
              var rules;
              if(document.styleSheets[i].cssRules){
                rules = document.styleSheets[i].cssRules;
              }else{
                rules = document.styleSheets[i].rules;
              }
              for(var j=0;j<rules.length;j++){
                if(rules[j].selectorText == '.el-table'){
                  a= rules[j].style;
                  break;
                }
              }
            }
            a.fontSize = val+'px';
          },
          // 全屏事件
          handleFullScreen(){
            let element = document.documentElement;
            if (this.fullscreen) {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
              }
            } else {
              if (element.requestFullscreen) {
                element.requestFullscreen();
              } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
              } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
              } else if (element.msRequestFullscreen) {
                // IE11
                element.msRequestFullscreen();
              }
            }
            this.fullscreen = !this.fullscreen;
          },
          pdfDl(){
            window.location.href=axios.defaults.baseURL+'/report/comm/personal?staffId='+this.$store.getters.staff.id+
                    "&dateCode=190101&status=4&type=0&token="+this.$store.getters.staff.token+"&systemType=1";
          },
          goTest(){
            window.location.href='/#/test2?id=1&type=2';
          },
            logClick(){
                this.$router.push('/dashboard');
            },
            closeTab(name){
                this.$store.commit("closeTab",name);
            },
            toTab(value){
                  this.$router.push(value.url);
                  this.$store.commit("setterClickTab",value.name);
            },
            onSubmit() {
//        console.log('submit!');
            },
            handleopen() {
                //console.log('handleopen');
            },
            handleclose() {
                //console.log('handleclose');
            },
            handleselect (path, i) {

            },
            logout () {
                this.$confirm('是否退出', '提示', {
                    type: 'warning'
                }).then(() => {
                    let  staffId=this.$store.getters.staff.id;
                    getLogout(staffId).then(data=>{
                        window.sessionStorage.removeItem("staff");
                        this.$router.options.routes.splice(2,router.options.routes.length-2);
                        this.$router.push('/login');
                    });
                }).catch(() => {

                });
            },
            updpwd(){
                this.homeForm.password='';
                this.homeForm.confirmPassword='';
               this.dialogFormVisible=true;
            },
            //折疊巡覽列
            collapse(){
             this.collapsed=!this.collapsed;
                if (this.collapsed){
                    this.logBg=false;
                }else {
                    this.logBg=true;
                }
            },
            //修改密碼
            modifyStaffPassword(formName){

                let str = this.isNull();
                if(str !== ""){
                    this.dialogVisible =true;
                    this.$alert(str, '提示', {
                        confirmButtonText: '确定',
                        type: 'error'
                    });
                }else {
                    this.$refs.homeForm.validate((valid) => {
                        if (valid) {
                            return modifyStaffPassword(this.homeForm.password).then(data => {
                                let {data: res = {}} = data;
                                if (res.errcode == 200) {
                                    this.$message({
                                        message: "修改成功",
                                        type: 'success'
                                    });
                                    this.dialogFormVisible = false;
                                    this.homeForm.password = '';
                                    this.homeForm.confirmPassword = '';
                                } else {
                                    this.$message({
                                        message: "修改失敗",
                                        type: 'warning'
                                    });
                                }
                            });
                        }
                    });
                }
            },
            isNull(){/*是否为空*/
                if(this.homeForm.password ==="" || this.homeForm.password === null){
                    return "請輸入新密碼"
                }
                if(this.homeForm.password.length <6 || this.homeForm.password.length > 20){
                    return "輸入新密碼長度在6至20之間"
                }
                if(this.homeForm.confirmPassword ==="" || this.homeForm.confirmPassword === null){
                    return "請確認新密碼"
                }
                if(this.homeForm.confirmPassword.length <6 || this.homeForm.confirmPassword.length > 20){
                    return "確認密碼長度在6至20之間"
                }
                if (this.homeForm.password !== this.homeForm.confirmPassword) {
                    return "兩次輸入密碼不一致";
                }
                return "";
            },
        },
        computed: {
            valDataType(){
                return document.body.clientWidth;
            },
            staff(){
                return this.$store.getters.staff;
            },
            routes(){
                return this.$router.options.routes;
            },
            tabs(){
                return this.$store.getters.tabs;
            },
            onRoutes(){
                  this.$store.commit("addTab",{name:this.$route.name,url:this.$route.path});
                  this.$store.commit("setterClickTab",this.$route.name);
                  return this.$route.fullPath;
            },
            overseaMemo(){
              return this.$store.getters.hasPermission("OVERSEA_MEMO");
            },

        },
        created(){
            /* console.log("============>>created");*/
        },
        beforeRouteEnter (to, from, next) {
            /*console.log("============>>beforeRouteEnter");*/
            next();
        },
        beforeMount(){
            /*console.log("============>>beforeMount");*/
        },
        mounted() {


          let fontSize = this.$store.getters.staff.fontSize+"px";
          let a = '';
          for(var i =0;i<document.styleSheets.length;i++){
            var rules;
            if(document.styleSheets[i].cssRules){
              rules = document.styleSheets[i].cssRules;
            }else{
              rules = document.styleSheets[i].rules;
            }
            for(var j=0;j<rules.length;j++){
              if(rules[j].selectorText == '.el-table'){
                a= rules[j].style;
                break;
              }
            }
          }
          a.fontSize = fontSize;
          a.color ='black';

        },
    }



</script>

<style scoped lang="scss">
  .el-form-item {
    margin-bottom: 5px;
  }
  .tab_list{
    margin: -20px 0px 0px -20px;
    background: #ffffff;
    border-bottom: 1px solid #c1b2b2;
  }

  .ssf{background: #fff;
    color: #000;
    border-radius: 0px;
    border: 1px solid #ddd;
    position: absolute;
    bottom: -14px;
    border-bottom: 1px solid #fff;
    border-top: 2px solid #228569;}

  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
      padding-right: 0px !important;
      padding-left: 0px !important;
    .header {
      height: 45px;
      line-height: 45px;
      background: #403838;
      border-bottom: 1px solid #ffffff;
      color: #fff;
      .topmenu {
        text-align: right;
        padding-right: 30px;
        float: right;
        .item{
          color: #000;
          .mark{
            font-size: 12px;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            margin: -10px 6px 0;
            min-width: 8px;
            text-align: center;
            border-radius: 0.6rem;
            padding: .25em .5em;
          }
        }
        .userinfo-inner {
          cursor: pointer;
          color:#333;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin: 10px 0px 10px 10px;
            float: right;
          }
          i{
            color:#fff;
          }
        }
      }
      .logo {
        height:60px;
        font-size: 15px;
        padding-left:10px;
        padding-right:10px;

        img {
          width: 70px;
          float: left;
          margin: 5px 10px 10px 2px;
        }
      }
      .logo-width{
        width:220px;

      }
      .logo-collapse-width{
      /*  width:65px;*/
        cursor: pointer;
      }
      .tools{
        padding: 0px 23px;
        width:14px;
        height:45px;
        line-height:45px;
        cursor: pointer;
        i{
          color:#666;
        }
      }
    }
    .main {
      display: flex;
      position: absolute;
      top: 45px;
      bottom: 0px;
      overflow: hidden;
      aside {
        flex:0 0 230px;
        width: 230px;
        .el-menu{
          height: 100%;
        }
      }
      .menu-collapsed{
        flex:0 0 60px;
        width: 60px;
      }
      .menu-expanded{
        flex:0 0 220px;
        width: 220px;
      }
      .content-container {
        flex:1;
        overflow-y: scroll;
        padding: 20px;
        .breadcrumb-container {
          border: solid 1px #e9e9e9;
          margin: 0 0 20px;
          padding: 10px;
          background: #ffffff;
          background: -moz-linear-gradient(top, #ffffff 0%, #f5f5f5 100%);
          background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#ffffff), color-stop(100%,#f5f5f5));
          background: -webkit-linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          background: -o-linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          background: -ms-linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          background: linear-gradient(top, #ffffff 0%,#f5f5f5 100%);
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f5f5f5',GradientType=0 );
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          -ms-border-radius: 4px;
          border-radius: 4px;
        }
        .content-wrapper {
          //background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }
  .el-col-6{width:auto;}
  #faart{ margin-bottom:20px;}

  .home_top_function{
    height: 45px;float: left;margin-right: 20px;cursor: pointer;
  }

  /* fade-transform */
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .5s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

.el-collapse-item__header{
  margin-left: 15px;
}

</style>




// WEBPACK FOOTER //
// src/views/Home.vue